import { applyMiddleware, createStore } from 'redux'
import createSagaMiddleware from 'redux-saga'
// import logger from 'redux-logger'
import reducers from './reducers'
import rootSaga from './sagas'

const saga = createSagaMiddleware()

const store = createStore(
  reducers,
  (window['devToolsExtension'] && process.env['NODE_ENV'] === 'development')
    ? window['devToolsExtension']()
    : undefined,
  // process.env['NODE_ENV'] === 'development'
  //   ? applyMiddleware(saga, logger)
  //   : applyMiddleware(saga)
  applyMiddleware(saga)
)

saga.run(rootSaga)

export default store
